import { callGetApi, callPostApiWithStatus } from "@/utils/apiWrapper";
import ReportAcConstant from "@/mixins/report/const/reportAcConstant";

// NZSC-3308: 리포트 궁금한 점(사전 문의) — 결제 후 모달·결제완료 화면·마이페이지 공용.
// api-public POST/GET /api/v1/report-qna/order/:order_seq (AuthGuard, 소유권·잠금 서버 판정).
// 응답 payload(camelCase): { orderSeq, reportSeq, question, questionDate, answer, reviewStatus,
//   locked, secondsUntilLock }. apiWrapper 가 code===0 에서 data 를 반환.

const BASE = ReportAcConstant.REPORT_QNA;

export const actions = {
  /** 내 질문/잠금 상태 조회. 모달·화면 진입 시. 실패 시 null. */
  async acGetReportQna(_ctx, orderSeq) {
    if (!orderSeq) return null;
    return await callGetApi({ url: `${BASE}/order/${orderSeq}` });
  },

  /**
   * 질문 추가/수정. 담당자 배정 전에만 성공.
   * HTTP 상태를 보존한 { ok, status, data }를 반환해 423 잠금과 네트워크 실패를 구분한다.
   */
  async acSubmitReportQna(_ctx, { orderSeq, question }) {
    if (!orderSeq) return null;
    return await callPostApiWithStatus({
      url: `${BASE}/order/${orderSeq}`,
      data: { question },
    });
  },
};

export default {
  namespaced: true,
  actions,
};
